import Logo from "../../components/Logo";

export default function AdminLogin() {
  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-navy-800 p-10">
        <Logo />
        <h1 className="mt-10 font-heading text-3xl font-extrabold text-white">Admin Console</h1>
        <p className="mt-3 text-sm text-slate-400 leading-relaxed">
          Sign in with your Google account. Access is granted to authorized Built2Last.live team members only.
        </p>
        <button
          onClick={login}
          data-testid="admin-google-login-btn"
          className="mt-10 w-full flex items-center justify-center gap-3 rounded-full bg-white text-slate-900 font-heading font-bold text-sm py-4 hover:bg-slate-200 transition-colors"
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1Z" />
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23Z" />
            <path fill="#FBBC05" d="M5.84 14.1a7.2 7.2 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84Z" />
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52Z" />
          </svg>
          SIGN IN WITH GOOGLE
        </button>
        <a href="/" data-testid="admin-back-to-site" className="mt-8 block text-center text-xs text-slate-500 hover:text-flame transition-colors">
          ← Back to Built2Last.live
        </a>
      </div>
    </div>
  );
}
